import { type FC, useEffect, useRef, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconArrowLeft } from '@redteclab/icons'

import { Button } from 'base-ui'

import { type OpenableControls } from '../../../../generic-hooks'
import { type SubOrderProductListProps } from '../../../hooks/useDirectContactFormOrderSelection'
import { useDirectFormDialogContext } from '../DirectContactFormDialogContext'

import { DirectContactFormOrderItemsCheckboxSelection } from './DirectContactFormOrderItemsCheckboxSelection'
import { DirectContactFormSubOrderItemsCheckboxSelection } from './DirectContactFormSubOrderItemsCheckboxSelection'

export const DirectContactFormOrderProductItemsSelection: FC<{
  modalControls: OpenableControls
}> = ({ modalControls }) => {
  const intl = useIntl()

  const [selectedSubOrderItems, setSelectedSubOrderItems] = useState<
    SubOrderProductListProps[]
  >([])
  const modalOpened = useRef(true)

  const {
    prefilledSubOrder,
    productList,
    setOrderSelectionDialogTitle,
    setProductList,
  } = useDirectFormDialogContext()

  useEffect(() => {
    if (
      selectedSubOrderItems.length === 0 &&
      productList.length > 0 &&
      modalOpened.current
    ) {
      setSelectedSubOrderItems(productList)
      modalOpened.current = false
    }
  }, [selectedSubOrderItems, productList])

  return (
    <>
      {!prefilledSubOrder && (
        <Button
          className="mb-4 mt-1 items-start justify-start text-s font-medium text-dark-brand tablet:flex"
          data-qa-id="direct-contact-form-back-button-to-card-items-selection"
          onClick={() => {
            setOrderSelectionDialogTitle(
              intl.formatMessage({ id: 'direct.contact.form.select.order' }),
            )
          }}
          startIcon={<IconArrowLeft />}
          variant="text"
        >
          <span className="text-dark-primary-max">
            <FormattedMessage id="direct.contact.form.back.to.order.selection" />
          </span>
        </Button>
      )}
      <div className="mt-auto flex h-full flex-col">
        {prefilledSubOrder ? (
          <DirectContactFormSubOrderItemsCheckboxSelection
            selectedSubOrderItems={selectedSubOrderItems}
            setSelectedSubOrderItems={setSelectedSubOrderItems}
          />
        ) : (
          <DirectContactFormOrderItemsCheckboxSelection
            selectedSubOrderItems={selectedSubOrderItems}
            setSelectedSubOrderItems={setSelectedSubOrderItems}
          />
        )}
        {selectedSubOrderItems.length > 0 ? (
          <div className="mt-auto flex w-full">
            <Button
              className="mb-2 mt-6 w-full tablet:mt-16"
              data-qa-id="direct-contact-form-confirm-items-selection"
              onClick={() => {
                setProductList(selectedSubOrderItems)
                modalControls.handleClose()
              }}
            >
              <FormattedMessage id="direct.contact.form.confirm.selection" />
            </Button>
          </div>
        ) : null}
      </div>
    </>
  )
}
